module.exports = __webpack_public_path__ + "img/step4.c2f6170d.jpg";